module.exports = __webpack_public_path__ + "img/dynamic-16.26b9fdb6.png";